//import { MultipleColors, SingleColor } from "react-countdown-circle-timer";

export interface QuizInitCountdownEntity {
	Seconds: number;
	Colors: {
		0: `#${string}`;
	} & {
		1: `#${string}`;
	} & `#${string}`[];
	ColorTime: { 0: number } & { 1: number } & number[];
    StrokeWidth: number;
}

export interface QuizConfigurationEntity {
	InitCountdownConfig: QuizInitCountdownEntity;
	PointsCounterDurationInSec: number;
	PointsCounterDelayInSec: number;
	DelayAfterAnswerInMS: number;
	ProgressBarInitialDelayInMS: number; //to make sure the browser sees a delay between width 100% and width 0%
}

export const QuizConfig: QuizConfigurationEntity = {
	InitCountdownConfig: {
		Seconds: 3,
		Colors: ['#39518E', '#39518E'],
		ColorTime: [0, 0],
		StrokeWidth: 8,
	},
	PointsCounterDurationInSec: 0.5,
	PointsCounterDelayInSec: 0,
	DelayAfterAnswerInMS: 1500,
	ProgressBarInitialDelayInMS: 200,
};
